/* eslint-disable class-methods-use-this */
import { RequestHeaders } from './RequestHeaders';
import { RequestStrategy } from './Strategy';
import AuthTokenProvider from '../Auth/AuthTokenProvider';

export class PrivateStrategy extends RequestStrategy {
  public getRequestHeaders(): RequestHeaders {
    return this.buildHeaders(AuthTokenProvider.getAuthenticationHeader());
  }
}
